<template>
  <div class="pa-1">
    <v-toolbar class="mb-3" :elevation="1">
      <v-btn @click="onPrevStep" text>
        Назад
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
              @click="saveAsPdf"
              :loading="loading"
              text>
        Сохранить
        <v-icon right>mdi-export-variant</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card :tile="true" :elevation="1" class="pa-5">
      <VueShowdown :markdown="text"></VueShowdown>
    </v-card>
  </div>
</template>

<script>
  import VueShowdown from 'vue-showdown';
  import html2pdf from 'html2pdf.js';
  import showdown from 'showdown';

  export default {
    name: "PlanViewer",
    components: VueShowdown,
    props: {
      plan: Array,
      roadmap: Object,
      onPrevStep: Function,
    },
    data() {
      return {
        loading: false,
      }
    },
    computed: {
      text() {
        const overview = this.roadmap.overview;
        const modules = this.plan.map(slug => this.$store.getters.conceptContent(slug));

        return [overview, ...modules].join('');
      }
    },
    methods: {
      saveAsPdf() {
        this.loading = true;

        const converter = new showdown.Converter();
        const html = converter.makeHtml(this.text);

        const opt = {
          margin: 1,
          filename: `${this.roadmap.title} guide.pdf`,
          image: {type: 'jpeg', quality: 0.99},
          pagebreak: {mode: 'avoid-all'},
          html2canvas: {scale: 2},
          jsPDF: {unit: 'in', orientation: 'portrait'}
        };

        html2pdf().set(opt).from(html).save()
            .finally(() => (this.loading = false))
      }
    }
  }
</script>

<style scoped>

</style>
